export default function getArrayFromDates (start, end) {
	let arr, dt;

	for(arr=[],dt=new Date(start); dt<=end; dt.setDate(dt.getDate()+1)){
		arr.push(new Date(dt));
	}
	
	return arr;
}
